import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SetNewPasswordAuthenticationGuard  {
  constructor(private _router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const isSetNewPassword = JSON.parse(localStorage.getItem('setnewpassword') || '{}');
      if (isSetNewPassword == true) {
        return true;
      } else {
        this._router.navigate(['/login']);
        return false;
      }
  }

}
